import { standardEmb, emblem3d, subPatch } from "../../images";
let embroideryList = [
  {
    img: standardEmb,
    title: "STANDARD EMBROIDERY",
  },
  {
    img: emblem3d,
    title: "3D EMBROIDERY",
  },
  {
    img: subPatch,
    title: "SUBLIMATED PATCH EMBROIDERY",
  },
];
export default embroideryList;
